export default __webpack_public_path__ + "static/media/about-us-4.df969445.png";